import { TYPE_SIZES } from '../../utils/globalConst.js';
import Loader from '../Loader/Loader.vue.js';
import { FadeTransition } from 'vue2-transitions';
import inputMixin from '../../utils/mixins/inputMixin.js';
import ClearSearchIcon from '../../assets/icons/24/Clear_search_24.vue.js';

//
var script = {
  name: 'InputControl',
  components: {
    Loader: Loader,
    ClearSearchIcon: ClearSearchIcon,
    FadeTransition: FadeTransition
  },
  mixins: [inputMixin],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    nameBuilder: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: TYPE_SIZES.large.value
    }
  },
  data: function () { return ({
    offsetPlaceholder: 0,
    visiblePlaceholder: true
  }); },
  computed: {
    rootClass: function rootClass() {
      var obj;

      return ( obj = {
        '_success': this.isValidDI && !this.isErrorDI,
        '_error': this.isErrorDI,
        '_focus': this.focused,
        '_disabled': this.disabled,
        '_hover': this.hovering
      }, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj );
    },

    inputTypeNative: function inputTypeNative() {
      return this.formItem.showPassword ? this.formItem.passwordVisible ? 'text' : 'password' : this.type;
    },

    placeholderValue: function placeholderValue() {
      var wordsCount = this.innerValue.split(' ').length;
      var placeholderWords = this.placeholder.split(' ');

      if (this.isEmptyValue) {
        placeholderWords.shift();
      }

      return placeholderWords.slice(wordsCount - 1).join(' ');
    },

    stylePlaceholder: function stylePlaceholder() {
      return {
        marginLeft: ((this.offsetPlaceholder) + "px"),
        visibility: this.visiblePlaceholder ? 'visible' : 'hidden'
      };
    },

    nativePlaceholder: function nativePlaceholder() {
      return this.nameBuilder ? '' : this.placeholder;
    }

  },

  created: function created() {
    this.$on('focusInputAfterShowPassword', this.focus);
  },

  mounted: function mounted() {
    if (this.nameBuilder) {
      this.updatePlaceholder();
    }
  },

  updated: function updated() {
    this.updatePlaceholder();
  },

  methods: {
    updatePlaceholder: function updatePlaceholder() {
      var placeholder = this.$refs.placeholder;
      var value = this.$refs.value;
      var control = this.$refs.input;

      if (placeholder && value && control) {
        var placeholderWidth = placeholder.offsetWidth;
        var valueWidth = value.offsetWidth;
        var maxWidth = control.offsetWidth;
        var summaryWidth = valueWidth + placeholderWidth;
        this.visiblePlaceholder = summaryWidth <= maxWidth;
        this.offsetPlaceholder = this.isEmptyValue ? valueWidth : 0;
      }
    }

  }
};

export default script;
